import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { BottomSheetComponent, DeviceService } from '@nomoh-monorepo/shared-common-ui';
import { ServicoCriarEditarComponent } from '../tipo-servico-modal/servico-criar-editar/servico-criar-editar.component';
import type { IServico } from '@nomoh-monorepo/shared-types';
import { NichoTermosService } from '@nomoh-monorepo/data-access-bardo-administrador';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-servico-form-modal',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    DialogModule,
    BottomSheetComponent,
    ServicoCriarEditarComponent,
    TranslateModule,
  ],
  templateUrl: './servico-form-modal.component.html',
})
export class ServicoFormModalComponent {
  public deviceService = inject(DeviceService);
  $nicho = inject(NichoTermosService).$nicho;


  @Input() set visible(value: boolean) {
    this.$visible.set(value);
  }
  @Input() tipoServicoId: string | null = null;
  @Input() servico: IServico | null = null;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() salvo = new EventEmitter<void>();

  @ViewChild('servicoCriarRef')
  servicoCriarRef?: ServicoCriarEditarComponent;

  $visible = signal<boolean>(false);
  $isLoading = signal<boolean>(false);

  fecharModal() {
    this.$visible.set(false);
    this.visibleChange.emit(false);
  }

  onSheetVisibleChange(visivel: boolean) {
    if (visivel) {
      this.$visible.set(true);
    } else {
      this.fecharModal();
    }
  }

  salvar() {
    this.servicoCriarRef?.salvar();
  }

  onServicoSalvo() {
    this.salvo.emit();
    this.fecharModal();
  }
}
